import React from 'react';

import AppsStore from '../../main/stores/AppsStore_LEGACY';
import AppsActions from '../../main/actions/AppsActions_LEGACY';
import AccountActions from '../../main/actions/AccountActions';
import Input from '../../common/components/core/Input';
import Button from '../../common/components/core/Button';
import Link from '../../common/components/core/Link';
import TimezoneList from '../../common/components/core/TimezoneList';

import { appTimezone } from '../../main/support/dateUtils';
import { SETTING_TIMEZONE_COPY } from '../../common/support/timezoneConstants';

type Props = {};

type State = {
  name: string;
  timezone: string;
};

export default class ScreenCreateApp extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      name: '',
      timezone: appTimezone,
    };
  }

  componentWillMount() {
    AppsStore.addChangeListener(this._onChange);
  }

  componentWillUnmount() {
    AppsStore.removeChangeListener(this._onChange);
    (this.refs.form as HTMLFormElement).removeEventListener('invalid', this._preventDefault, true);
  }

  componentDidMount() {
    (this.refs.form as HTMLFormElement).addEventListener('invalid', this._preventDefault, true);
  }

  _onChange = () => {
    if (!(this.refs.name as Input).isInputValid()) {
      (this.refs.name as Input).validate();
    }
  };

  _createApp = () => {
    AppsActions.createApp(this.state);
  };

  _preventDefault = (ev) => {
    ev.preventDefault();
  };

  _onNameChange = (event) => {
    this.setState({ name: event.value });
  };

  _onTimezoneChange = (timezone) => {
    this.setState({ timezone });
  };

  render() {
    return (
      <div className="loggedout--container">
        <div className="login-bg" />
        <div className="login-side-bar">
          <div className="welcome-text-container">
            <h1 className="welcome-text">Create a new App</h1>
          </div>
        </div>
        <div className="login-container">
          <form role="form" id="form_login" className="login-form h_mb-10" ref="form" onSubmit={this._preventDefault}>
            <div className="modal-body login-form">
              <div className="h_py-10 no-border h_fw-400">
                <span className="login-signup">
                  Creating an app is easy, just choose a name and time zone, or{' '}
                  <Link onClick={AccountActions.logout} testid="create-app__click-to-sign-out">
                    sign out
                  </Link>
                  .
                </span>
              </div>
              <div className="sign-up-container">
                <div className="sign-up-1">
                  <Input
                    onChange={this._onNameChange}
                    value={this.state.name}
                    name="name"
                    ref="name"
                    label="App name"
                    required
                    testid="create-app__name"
                  />
                </div>
              </div>
              <div className="h_maw-500 h_pt-10">{SETTING_TIMEZONE_COPY}</div>
              <TimezoneList onChange={this._onTimezoneChange} value={this.state.timezone} className="h_my-10" />
            </div>
            <div className="text-center modal-footer no-border loggedout--sign-in">
              <Button className="btn-signup" onClick={this._createApp} testid="logged-out__create-app">
                Create App
              </Button>
            </div>
          </form>
          <div className="itself-center text-center login-signup">
            Questions? We are here to{' '}
            <Link href="https://support.branch.io" testid="create-app__help-link">
              help
            </Link>
            .
          </div>
        </div>
      </div>
    );
  }
}
